import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import BoxedItem from '../../../../components/global/BoxedItem';
import LockIcon from '../../../../components/icons/LockIcon';
import Logo from '../../../../components/global/Logo';
import { getAccountLogoFromHierarchyItem } from '../WebGalleryPasswordEntry/helpers';
import { HierarchyItemForPasswordValidation } from '../../graphql/queries/hierarchy-item';
import Button from '../../../../components/global/Button';

const WebGalleryNoAccess = () => {
  const { recordId } = useParams();
  const history = useHistory();

  const { data: { hierarchyItem } = {} } = useQuery(
    // Since this screen looks very much the same with Password Access
    // we can reuse this query to fetch the account logo.
    HierarchyItemForPasswordValidation,
    {
      variables: {
        id: recordId,
      },
      skip: !recordId,
    },
  );

  const accountLogoUrl = getAccountLogoFromHierarchyItem(hierarchyItem);

  return (
    <div className="web-gallery-access-container">
      <header className="web-gallery-access-header">
        {accountLogoUrl && (
          <img
            src={accountLogoUrl}
            alt=""
            className="web-gallery-access-header-account-logo"
          />
        )}

        <Logo iconOnly className="web-gallery-access-header-waldo-logo" />
      </header>

      <BoxedItem className="web-gallery-access-box">
        <h3 className="web-gallery-access-box-title">
          <LockIcon /> Restricted Content
        </h3>

        <p className="text-center">
          The owner of this gallery has restricted access to contributors and
          invited members only.
        </p>

        {history.length > 2 && (
          <div className="text-center">
            <Button
              btnStyle="link"
              onClick={() => {
                history.goBack();
              }}
            >
              &larr; Go back
            </Button>
          </div>
        )}
      </BoxedItem>
    </div>
  );
};

export default WebGalleryNoAccess;
